var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.9356 12.5517C22.3831 12.5517 21.9439 12.1126 21.9439 11.5601V9.74673C21.9439 8.3584 21.3489 7.02673 20.3289 6.09173C19.2806 5.14256 17.9348 4.7034 16.5181 4.8309C14.1381 5.05756 12.0556 7.48006 12.0556 10.0017V11.2767C12.0556 11.8292 11.6164 12.2684 11.0639 12.2684C10.5114 12.2684 10.0723 11.8292 10.0723 11.2767V10.0017C10.0723 6.46006 12.9339 3.18756 16.3198 2.86173C18.2889 2.67756 20.1873 3.3009 21.6464 4.63256C23.0914 5.9359 23.9131 7.8059 23.9131 9.74673V11.5601C23.9131 12.1126 23.4739 12.5517 22.9356 12.5517Z",
    fill: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2766 12.6933C27.0866 11.3758 25.1316 10.7383 22.27 10.7383H11.73C8.8683 10.7383 6.9133 11.3758 5.7233 12.6933C4.34913 14.2233 4.39163 16.2633 4.54747 17.6799L5.53913 25.5708C5.83663 28.3333 6.9558 31.1666 13.0475 31.1666H20.9525C27.0441 31.1666 28.1633 28.3333 28.4608 25.5849L29.4525 17.6658C29.6083 16.2633 29.6366 14.2233 28.2766 12.6933ZM11.9283 18.6291H11.9141C11.135 18.6291 10.4975 17.9916 10.4975 17.2124C10.4975 16.4333 11.135 15.7958 11.9141 15.7958C12.7075 15.7958 13.345 16.4333 13.345 17.2124C13.345 17.9916 12.7075 18.6291 11.9283 18.6291ZM21.845 18.6291H21.8308C21.0516 18.6291 20.4141 17.9916 20.4141 17.2124C20.4141 16.4333 21.0516 15.7958 21.8308 15.7958C22.6241 15.7958 23.2616 16.4333 23.2616 17.2124C23.2616 17.9916 22.6241 18.6291 21.845 18.6291Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.1ef83a4c543a79b4bcc49590c12fb001.svg";
export { ForwardRef as ReactComponent };